export default __webpack_public_path__ + "static/media/background.6ae689d0.jpg";